import Yup from 'utils/validation/yup-extensions';
import Box from '@mui/material/Box';
import AppWrappedDate from 'pages/ApplicationRequest/components/containers/AppWrappedDate';
import AppWrappedRadios from 'pages/ApplicationRequest/components/containers/AppWrappedRadios';
import AppWrappedTextbox from 'pages/ApplicationRequest/components/containers/AppWrappedTextbox';

/**
 * Research supplement form fields for collecting CITI training and study information.
 * @param {{ formik: import('formik').FormikProps<object> }} props
 */
export const ResearchSupplement = ({ formik }) => {
	const citiTrainingValue = formik.values[FORM_FIELD_KEYS.RESEARCH_CITI_TRAINING];

	return (
		<Box
			sx={{
				'& h6': {
					marginBottom: '0',
				},
			}}
		>
			<AppWrappedRadios
				name={FORM_FIELD_KEYS.RESEARCH_CITI_TRAINING}
				label='Have you completed CITI Privacy and Security Training?'
				formik={formik}
				options={CITI_TRAINING_OPTIONS}
				isRequired
			/>
			{citiTrainingValue === CITI_TRAINING_OPTIONS[0] && (
				<AppWrappedDate
					name={FORM_FIELD_KEYS.RESEARCH_CITI_TRAINING_DATE}
					label='Date of completion'
					formik={formik}
					isRequired
				/>
			)}
			<AppWrappedRadios
				name={FORM_FIELD_KEYS.RESEARCH_STUDY_TYPE}
				label='What type of Study?'
				formik={formik}
				options={STUDY_TYPE_OPTIONS}
				isRequired
			/>
			<AppWrappedTextbox
				name={FORM_FIELD_KEYS.RESEARCH_STUDY_ID}
				label='Study ID'
				formik={formik}
				isRequired
			/>
		</Box>
	);
};

const CITI_TRAINING_OPTIONS = ['Yes', 'No'];
const STUDY_TYPE_OPTIONS = ['UPMC', 'University of Pittsburgh'];

export const FORM_FIELD_KEYS = {
	RESEARCH_CITI_TRAINING: 'RESEARCH_CITI_TRAINING',
	RESEARCH_CITI_TRAINING_DATE: 'RESEARCH_CITI_TRAINING_DATE',
	RESEARCH_STUDY_TYPE: 'RESEARCH_STUDY_TYPE',
	RESEARCH_STUDY_ID: 'RESEARCH_STUDY_ID',
};

export const INITIAL_VALUES = {
	[FORM_FIELD_KEYS.RESEARCH_CITI_TRAINING]: '',
	[FORM_FIELD_KEYS.RESEARCH_CITI_TRAINING_DATE]: '',
	[FORM_FIELD_KEYS.RESEARCH_STUDY_TYPE]: '',
	[FORM_FIELD_KEYS.RESEARCH_STUDY_ID]: '',
};

export const VALIDATION_SCHEMA = {
	[FORM_FIELD_KEYS.RESEARCH_CITI_TRAINING]: Yup.string().required(
		'This field is required.',
	),
	[FORM_FIELD_KEYS.RESEARCH_CITI_TRAINING_DATE]: Yup.string().when(
		FORM_FIELD_KEYS.RESEARCH_CITI_TRAINING,
		{
			is: 'Yes',
			then: schema => schema.required('Date of completion is required.'),
			otherwise: schema => schema.notRequired(),
		},
	),
	[FORM_FIELD_KEYS.RESEARCH_STUDY_TYPE]: Yup.string().required(
		'This field is required.',
	),
	[FORM_FIELD_KEYS.RESEARCH_STUDY_ID]: Yup.string().required(
		'This field is required.',
	),
};
